import React from 'react'
import styled from 'styled-components'
import { Trans } from '@lingui/react'
import { useApolloClient } from '@apollo/client'

import { delay } from '../../../util/index'
import isTenantAvailable from '../../../api/isTenantAvailable'
import useAppState from '../../hooks/useAppState'
import Modal from '../onboarding/OnboardingModal'
import ErrorPage from '../error/ErrorPage'
import useTracking from '../../hooks/useTracking'

const REQUEST_TIMEOUT = 10000

const RegisterModalLoading = () => {
    const apolloClient = useApolloClient()
    const { refresh, currentTenant } = useAppState()
    const { trackError } = useTracking()

    const tenantInput = currentTenant === null ? '' : currentTenant.id

    const checkIsTenantAvailable = async () => {
        try {
            const isReady = await isTenantAvailable(apolloClient, tenantInput)
            if (isReady) {
                refresh()
            } else {
                await delay(REQUEST_TIMEOUT)
                return checkIsTenantAvailable()
            }
        } catch (e) {
            trackError(e)
            return <ErrorPage error={e.message} />
        }
        return null
    }
    checkIsTenantAvailable()

    return (
        <Modal
            title={<Trans id="Finishing" />}
            subTitle={
                <Trans id="Hang in there, we are finishing the installation!" />
            }
        >
            <RegisterModalContainer>
                <Message>
                    <Trans id="Finishing installation..." />
                </Message>
                <Message>
                    <Trans id="This will take approximately 5 minutes. You'll be
                        notified by mail when we are ready, or you can just wait
                        here." />
                </Message>
            </RegisterModalContainer>
        </Modal>
    )
}

const RegisterModalContainer = styled.div`
    min-height: 15vh;
    overflow: auto;
`

const Message = styled.div(
    ({ theme }) => `
    padding-top: ${theme.spacingSmall}rem;
    padding-bottom: ${theme.spacingSmall}rem;
    width: 100%;
`,
)

export default RegisterModalLoading
